import { createStore, applyMiddleware } from "redux";
import rootReducer from "../reducers";
import { Middleware, PermissionMiddleware } from "./Middleware";

const middleWares = [Middleware, PermissionMiddleware];
export default createStore(rootReducer, applyMiddleware(...middleWares));